/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { Dispatch } from 'redux';
import * as taskActions from '../actions/taskActions';

export function useFetchCurrentTask(dispatch: Dispatch): boolean {
  const [isLoading, setIsLoading] = React.useState(true);

  async function load() {
    await taskActions.fetchCurrentTask()(dispatch);
    setIsLoading(false);
  }

  React.useEffect(() => {
    (async () => await load())();
  }, []);

  return isLoading;
}
